import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f94abc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "plan",
  name: "plan"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box_swiper" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!
  const _component_LeftOutlined = _resolveComponent("LeftOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_RightOutlined = _resolveComponent("RightOutlined")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_typography = _resolveComponent("a-typography")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 专利技术能力 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Swiper, {
          slidesPerView: "auto",
          speed: 600,
          navigation: {prevEl:'.button_prev',nextEl:'.button_next',disabledClass:'button_disabled'}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tab.list, (item, index) => {
              return (_openBlock(), _createBlock(_component_SwiperSlide, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    class: _normalizeClass({active:(index+1)===$data.tab.active}),
                    onClick: ($event: any) => ($data.tab.active=index+1)
                  }, _toDisplayString(item.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_4)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["navigation"]),
        _createVNode(_component_a_button, {
          type: "link",
          class: "button_prev"
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_LeftOutlined)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_button, {
          type: "link",
          class: "button_next"
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_RightOutlined)
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _createVNode(_component_a_tabs, {
        ref: "tab",
        activeKey: $data.tab.active,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => (($data.tab.active) = $event)),
        centered: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tab.list, (item, index) => {
            return (_openBlock(), _createBlock(_component_a_tab_pane, {
              key: index+1,
              tab: item.title
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["item", `i_${index+1} ${$data.tab.show===index+1?'tab_show':''}`])
                }, [
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        class: "box_content",
                        xs: 24,
                        md: 16
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_typography_title, { level: 5 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */),
                              _createVNode(_component_a_typography_paragraph, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("ul", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.text, (v, i) => {
                                      return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(v), 1 /* TEXT */))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */),
                              _createCommentVNode("<a-space :size=\"$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'\">"),
                              _createCommentVNode("  <a-button type=\"link\" class=\"button_n_3\" target=\"_blank\""),
                              _createCommentVNode("            @click=\"item.click\">"),
                              _createCommentVNode("    了解更多"),
                              _createCommentVNode("  </a-button>"),
                              _createCommentVNode("</a-space>")
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */),
                      _createVNode(_component_a_col, {
                        class: "box_image",
                        xs: 0,
                        md: 8
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ], 2 /* CLASS */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["tab"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["activeKey"])
    ])
  ]))
}